var map = {
	"./index_bg.jpg": "5ZbD",
	"./logo.png": "KItN",
	"./wjfz_icon.png": "qACm",
	"./wjfz_word.png": "RyfU",
	"./ys_bg.jpg": "zYcj"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0tcK";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image ^\.\/.*$
// module id = 0tcK
// module chunks = 0